


































import Component, { mixins } from 'vue-class-component';
import { CustomerShowModel } from '@/context/customer/model/CustomerShowModel';
import { customerApi } from '@/context/customer/api/CustomerApi';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';

@Component({
  components: { ProgressSpinnerWrapper, DetailRow }
})
export default class CustomerShowContainer extends mixins(ShowContainer) {
  model!: CustomerShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await customerApi.show(id);
    this.model = response?.data?.view;
  }
}
